import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import { useTheme } from "./hooks/useTheme";
import PencilGraphiteBackground from "./components/PencilGraphiteBackground";
import CanvasBreathingLight from "./components/CanvasBreathingLight";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Technologies from "./components/Technologies";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Portfolio from "./pages/Portfolio";
import "./App.css";

function Home() {
  const { isDarkMode } = useTheme();

  return (
    <div
      className={`App relative min-h-screen transition-colors duration-700 ${
        isDarkMode ? "bg-graphite-darker" : "bg-graphite-darker"
      }`}
      role="main"
    >
      <CanvasBreathingLight />
      <PencilGraphiteBackground intensity="light" />

      <div className="relative z-10">
        <Header />
        <main role="main" aria-label="Main content">
          <Hero />
          <Services />
          <Technologies />
          <Contact />
        </main>
        <Footer />
      </div>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/portfolio" element={<Portfolio />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
